import { useDispatch, useSelector } from 'react-redux';
import { selectMessageAttachmentData, setMessageAttachmentValue } from '../../../../../../features/chats/chats-slice';
import ImageAttachmentPreviewModal from './image-attachment-preview-modal';
import FileAttachmentPreviewModal from './fiel-attachement-preview-modal';

export default function ChatAttachmentPreview() {
    const dispatch = useDispatch();

    const {
        imageUrl,
        isImagePreviewOpen,
        fileUrl,
        isFilePreviewOpen,
        isLoadingFile,
        fileName,
        fileType,
    } = useSelector(selectMessageAttachmentData);

    const handleCloseImagePreview = () => {
        dispatch(setMessageAttachmentValue({ key: 'isImagePreviewOpen', value: false }));
        dispatch(setMessageAttachmentValue({ key: 'fileName', value: null }));
        dispatch(setMessageAttachmentValue({ key: 'fileType', value: null }));
    };

    const handleCloseFilePreview = () => {
        if (fileUrl) {
            URL.revokeObjectURL(fileUrl);
        }

        dispatch(setMessageAttachmentValue({ key: 'isFilePreviewOpen', value: false }));
        dispatch(setMessageAttachmentValue({ key: 'fileUrl', value: null }));
        dispatch(setMessageAttachmentValue({ key: 'fileName', value: null }));
        dispatch(setMessageAttachmentValue({ key: 'fileType', value: null }));
        dispatch(setMessageAttachmentValue({ key: 'isLoadingFile', value: false }));
    };

    return (
        <>
            <ImageAttachmentPreviewModal
                isOpen={isImagePreviewOpen}
                imageUrl={imageUrl}
                fileName={fileName ?? ''}
                onClose={handleCloseImagePreview}
            />

            <FileAttachmentPreviewModal
                isOpen={isFilePreviewOpen}
                fileUrl={fileUrl}
                fileName={fileName ?? ''}
                fileType={fileType ?? ''}
                isLoading={isLoadingFile}
                onClose={handleCloseFilePreview}
            />
        </>
    );
}